import {
  USER_RECEIVE,
  LOGOUT_COMPLETE,
  USER_ACCEPT_TERMS_REQUEST_COMPLETE,
  USER_ACCEPT_TERMS_REQUEST_FAILED,
} from '../actions';

import {
  SETTINGS_CHANGE_SUCCESS,
  SETTINGS_CHANGE_FAILED,
  SETTINGS_START_EDITING,
} from '../settings/actions/settings';

import { EMAIL_CHANGE } from '../settings/actions/email';
import { PASSWORD_CHANGE } from '../settings/actions/password';
import {
  DISPLAY_NAME_CHANGE,
  UPDATE_DISPLAY_NAME,
} from '../settings/actions/display-name';

import {
  ALERT_SETTINGS_CHANGE_SUCCESS,
  ALERT_SETTINGS_CHANGE,
} from '../settings/actions/alert-settings';

export default (
  state = {
    isAuthenticated: false,
    me: undefined,
    id: undefined,
    name: undefined,
    settings: undefined,
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      const { infoPageMap } = action.market;

      return {
        ...state,
        infoPageMap,
      };
    }
    case 'SESSION_RECEIVE': {
      return {
        ...state,
        isAuthenticated: !!action.session.loggedIn,
        loading: false,
      };
    }
    case USER_RECEIVE: {
      return {
        ...state,
        me: action.me,
        isAuthenticated: true,
        loading: false,
      };
    }

    case LOGOUT_COMPLETE: {
      return {
        ...state,
        isAuthenticated: false,
        me: undefined,
      };
    }

    case SETTINGS_START_EDITING: {
      return {
        ...state,
        settings: {
          editing: action.settings,
          errors: undefined,
          saving: false,
        },
      };
    }

    case EMAIL_CHANGE:
    case PASSWORD_CHANGE:
    case DISPLAY_NAME_CHANGE: {
      return {
        ...state,
        settings: {
          ...state.settings,
          saving: true,
        },
      };
    }

    case SETTINGS_CHANGE_SUCCESS: {
      return {
        ...state,
        settings: {
          ...state.settings,
          editing: undefined,
          errors: undefined,
          saving: false,
        },
      };
    }

    case SETTINGS_CHANGE_FAILED: {
      const errors = {
        'registration.username-taken': 'name',
        'auth.invalid-credentials': 'password',
        'registration.password-length': 'password',
        'registration.invalid-email': 'email',
        'registration.email-invalid': 'email',
        'registration.email-in-use': 'email',
        'registration.verification-mail-not-sent': 'email',
        'validation.email-invalid': 'email',
        'request.invalid-parameter': 'displayName',
      };

      const error = errors[action.error];

      return {
        ...state,
        settings: {
          ...state.settings,
          saving: false,
          errors: {
            ...state.settings.errors,
            [error]: action.error,
          },
        },
      };
    }

    case ALERT_SETTINGS_CHANGE:
    case ALERT_SETTINGS_CHANGE_SUCCESS: {
      let settings = {};
      if (Array.isArray(action.setting)) {
        settings = action.setting.reduce((acc, curr) => {
          acc[curr.setting] = curr.value;
          return acc;
        }, {});
      } else {
        settings = {
          [action.setting.setting]: action.setting.value,
        };
      }
      return {
        ...state,
        me: {
          ...state.me,
          alertSettings: {
            ...state.me.alertSettings,
            ...settings,
          },
        },
      };
    }

    case UPDATE_DISPLAY_NAME: {
      return {
        ...state,
        me: {
          ...state.me,
          displayName: action.displayName,
        },
      };
    }

    case USER_ACCEPT_TERMS_REQUEST_COMPLETE: {
      return {
        ...state,
        me: {
          ...state.me,
          updatedTerms: [],
        },
      };
    }

    case USER_ACCEPT_TERMS_REQUEST_FAILED: {
      return {
        ...state,
        me: {
          ...state.me,
          acceptPolicyError: true,
        },
      };
    }

    default:
  }

  return state;
};
